<template>
    <div
        :class="[
            {
                'has-error': v && v.$anyError,
                'is-required': isRequired,
            },
            classes,
            name ? name : '',
        ]"
        class="field"
        :disabled="iniDisabled">
        <label class="label" v-if="showLabel && label">{{ label }}</label>

        <!--TEXT-->
        <div
            :class="{
                'field has-addons': !!this.$slots.append || !!this.$slots.prepend,
            }">
            <!--prepend-->
            <div class="control" v-if="!!this.$slots.prepend">
                <slot name="prepend" />
            </div>

            <div class="control is-expanded">
                <!--CHECKBOX-->
                <template v-if="type == 'CHECKBOX'">
                    <div class="checkbox">
                        <label class="b-checkbox checkbox d-inline"
                            ><input
                                type="checkbox"
                                autocomplete="on"
                                true-value="true"
                                :value="selected"
                                :checked="selected"
                                @input="onCheckBoxChange"
                                :disabled="iniDisabled" /><span class="check"></span
                            ><span class="control-label">{{ label }}</span></label
                        >
                    </div>
                </template>
                <!--COUNTRY-->
                <template v-else-if="type == 'COUNTRY'">
                    <selectCountries v-model="selected" :isDisabled="iniDisabled" @input="onValueChange" />
                </template>
                <!--LANGUAGE
        <template v-else-if="type == 'LANGUAGE'">
          <selectLanguages v-model="selected" :isDisabled="iniDisabled" @input="onChange" />
        </template>
        -->
                <!--NATIONALITY-->
                <template v-else-if="type == 'NATIONALITY'">
                    <selectNationality
                        v-model="selected"
                        :isDisabled="iniDisabled"
                        :editMode="iniDisabled"
                        @input="onValueChange" />
                </template>
                <!--CURRENCY-->
                <template v-else-if="type == 'CURRENCY'">
                    <CurrencyView
                        :label="label"
                        :isDisabled="iniDisabled"
                        :v="v"
                        v-model="selected"
                        @input="onValueChange" />
                </template>
                <!--TOGGLE-->
                <template v-else-if="type == 'TOGGLE'">
                    <toggleButton
                        v-model="selected"
                        :color="color"
                        @input="onToggleChange"
                        :label="label"
                        :iniDisabled="iniDisabled" />
                </template>
                <!--SELECT-->
                <template v-else-if="type == 'SELECT'">
                    <template v-if="renderAsChecks">
                        <div class="field" v-for="(option, i) in options" :key="`${_uid}_${i}`">
                            <div class="checkbox">
                                <label
                                    class="d-inline"
                                    :class="isMultiple ? 'b-checkbox checkbox' : 'b-radio radio'"
                                    :disabled="iniDisabled"
                                    ><input
                                        :name="_uid"
                                        :type="isMultiple ? 'checkbox' : 'radio'"
                                        :value="optionsValueField ? option[optionsValueField] : option"
                                        @input="onChangeAsChecks"
                                        :disabled="iniDisabled"
                                        :checked="
                                            value &&
                                            value.indexOf(optionsValueField ? option[optionsValueField] : option) > -1
                                        " /><span class="check"></span
                                    ><span class="control-label">{{
                                        optionsTextField ? option[optionsTextField] : option
                                    }}</span></label
                                >
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="control is-expanded">
                            <span class="select is-fullwidth" :class="{ 'is-multiple': isMultiple }">
                                <select
                                    v-model="selected"
                                    @input="onChange"
                                    :multiple="isMultiple"
                                    :disabled="iniDisabled"
                                    :size="isMultiple ? 4 : 0">
                                    <template v-if="!iniDisabled && !disablePlaceholder">
                                        <option v-if="selected == null" :value="null" disabled hidden>
                                            {{ placeholder ? placeholder : $t('choose') }}
                                        </option>
                                    </template>
                                    <option
                                        v-for="(option, index) in options"
                                        :value="optionsValueField ? option[optionsValueField] : option"
                                        :key="`${_uid}__${index}`">
                                        {{ optionsTextField ? option[optionsTextField] : option }}
                                    </option>
                                </select>
                            </span>
                        </div>
                    </template>
                </template>
                <!--CUSTOM-->
                <template v-else-if="type == 'CUSTOM'">
                    <slot name="custom" />
                </template>
            </div>

            <!--append-->
            <div class="control" v-if="!!this.$slots.append">
                <slot name="append" />
            </div>
        </div>

        <span v-if="v && v.$anyError" class="help is-danger">
            <slot name="onError" />
        </span>
        <span class="help info" v-if="!!this.$slots.help">
            <slot name="help" />
        </span>
    </div>
</template>

<script>
const selectCountries = () => import('./../components/CountriesSelect.vue');
//const selectLanguages = () => import("./../components/LanguagesSelect.vue");
const toggleButton = () => import('./../components/ToggleButton.vue');

const selectNationality = () => import('./../components/NationalitiesSelect.vue');
const CurrencyView = () => import('./../components/CurrencyView.vue');

export default {
    name: 'chooseInput',
    components: {
        selectCountries,
        //selectLanguages,
        toggleButton,
        CurrencyView,
        selectNationality,
    },
    props: {
        id: { type: String },
        type: { type: String, default: 'SELECT' },
        v: [Object, Function],
        label: String,
        iniDisabled: { type: Boolean, default: false },
        value: [String, Object, Boolean, Array, Number],
        placeholder: String,
        disablePlaceholder: { type: Boolean, default: false },
        classes: String,
        //allowMultiple: { type: Boolean, default: false }, todo
        options: Array,
        optionsValueField: String,
        optionsTextField: String,
        isMultiple: { type: Boolean, default: false },
        renderAsChecks: { type: Boolean, default: false },
        color: [String, Object], // for toggle colours
    },
    data() {
        return {
            selected: null,
        };
    },
    computed: {
        showLabel() {
            if (this.type == 'CHECKBOX' || this.type == 'TOGGLE' || this.type == 'CURRENCY') {
                return false;
            }
            return true;
        },
        name() {
            if (this.id) {
                return '_' + this.id;
            } else if (this.label) {
                //get name from label
                return '_' + this.label.trim().toLowerCase().replaceAll(' ', '').replaceAll('/', '');
            } else {
                return false;
            }
        },
        isRequired() {
            return this.v && this.v.required === false;
        },
    },
    watch: {
        value() {
            this.handleValue();
        },
    },
    created() {
        this.handleValue();
    },
    methods: {
        handleValue() {
            //if isMultiple, selected must be an array
            if (this.isMultiple) {
                if (Array.isArray(this.value)) {
                    this.selected = this.value;
                } else {
                    this.selected = this.value ? [this.value] : [];
                }
            } else {
                if (Array.isArray(this.value)) {
                    if (this.value.length > 0) {
                        this.selected = this.value[0];
                    } else {
                        this.selected = null;
                    }
                } else {
                    this.selected = this.value;
                }
            }
        },
        onCheckBoxChange(event) {
            var value = event.target.checked;
            this.selected = value;
            this.$emit('input', value);
        },
        onChangeAsChecks(event) {
            var checkboxes = document.getElementsByName(this._uid);
            var checked = [];
            for (var i = 0, n = checkboxes.length; i < n; i++) {
                if (checkboxes[i].checked) {
                    checked.push(checkboxes[i].value);
                }
            }
            if (this.isMultiple) {
                this.selected = checked;
            } else {
                this.selected = checked[0];
            }
            //this.selected = checked;
            this.$emit('input', this.selected);
        },
        onValueChange(value) {
            this.selected = value;
            this.$emit('input', value);
        },
        onChange(event) {
            var value = event.target.value;
            this.selected = value;
            this.$emit('input', value);
        },
        onToggleChange(value) {
            this.selected = value;
            this.$emit('input', value);
        },
    },
    i18n: {
        messages: {
            en: {
                choose: 'Choose',
            },
            fr: {
                choose: 'Choisir',
            },
            nl: {
                choose: 'Kies',
            },
        },
    },
};
</script>
